export interface ProductPricing {
  price: number;
  originalPrice: number;
  discount: number;
}

export interface PricingConfig {
  pix: ProductPricing;
  albumCarre: ProductPricing;
  albumPaysage: ProductPricing;
  albumPremium: ProductPricing;
  tiragesPhotos: ProductPricing;
  yearbook: ProductPricing;
}

// Prix par défaut (fallback)
export const DEFAULT_PRICING: PricingConfig = {
  pix: {
    price: 16,
    originalPrice: 20,
    discount: 40,
  },
  albumCarre: {
    price: 27.99,
    originalPrice: 34.99,
    discount: 40,
  },
  albumPaysage: {
    price: 27.99,
    originalPrice: 34.99,
    discount: 40,
  },
  albumPremium: {
    price: 39.99,
    originalPrice: 49.99,
    discount: 40,
  },
  tiragesPhotos: {
    price: 25,
    originalPrice: 30,
    discount: 40,
  },
  yearbook: {
    price: 22.79,
    originalPrice: 28.49,
    discount: 40,
  },
};

/**
 * Récupère les prix depuis #app-data-pricing ou utilise les prix par défaut
 */
export function getPricing(): PricingConfig {
  const appDataPricing = document.getElementById('app-data-pricing');
  
  if (!appDataPricing) {
    return DEFAULT_PRICING;
  }

  const getProductPricing = (productKey: string): ProductPricing => {
    const price = parseFloat(appDataPricing.getAttribute(`data-${productKey}-price`) || '');
    const originalPrice = parseFloat(appDataPricing.getAttribute(`data-${productKey}-original`) || '');
    const discount = parseInt(appDataPricing.getAttribute(`data-${productKey}-discount`) || '');

    const defaultPricing = DEFAULT_PRICING[productKey as keyof PricingConfig];

    return {
      price: isNaN(price) ? defaultPricing.price : price,
      originalPrice: isNaN(originalPrice) ? defaultPricing.originalPrice : originalPrice,
      discount: isNaN(discount) ? defaultPricing.discount : discount,
    };
  };

  return {
    pix: getProductPricing('pix'),
    albumCarre: getProductPricing('album-carre'),
    albumPaysage: getProductPricing('album-paysage'),
    albumPremium: getProductPricing('album-premium'),
    tiragesPhotos: getProductPricing('tirages-photos'),
    yearbook: getProductPricing('yearbook'),
  };
}

/**
 * Formate un prix en string avec le symbole €
 */
export function formatPrice(price: number): string {
  return price % 1 === 0 ? `${price}€` : `${price.toFixed(2).replace('.', ',')}€`;
}

/**
 * Formate une remise en pourcentage
 */
export function formatDiscount(discount: number): string {
  return `-${discount}%`;
}
